export const ParticleBridge = {
  // Compatibility facade shared by the existing game and wallet consumers.
  authProvider: "particle",
  getAccessToken: null,
  // Connection status
  connected: false,
  connectionStatus: "",
  provider: null,

  // disconnect: () => {},

  loginAuthKit: () => {},

  handleLogout: () => {},

  openWallet: () => {},

  sendTransaction: (tx) => {},

  getEvmAddress: () => {},

  handleLoginGoogle: () => {},

  handleLoginX: () => {},

  handleLoginApple: () => {},

  getUserInfo: () => {},

  getChainId: () => {},

  switchChain: (chainId) => {},

  getSigner: () => {},
};
